import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { OpensearchPaginationCursorSchema } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ReturnTableInputSchema = z.object({
  advancedFiltersData: z.array(AdvancedFilterDataSchema),
  type: createEnum(ReturnTypeEnum).optional(),
  sort: z
    .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
    .nullish(),
  search: z.string().nullish(),
  barcode: z.string().nullish(),
  merchantTimezone: z.string().nullish(),
  opensearchToken: OpensearchPaginationCursorSchema.nullish(),
});

export type ReturnTableInput = z.infer<typeof ReturnTableInputSchema>;
